module.exports = __webpack_public_path__ + "img/catalogo.f9196be7.svg";